export type ChatComposerKey = {
  key: string;
  shiftKey: boolean;
  isComposing: boolean;
  hasFinePointer: boolean;
};

export function shouldSubmitChatComposer(event: ChatComposerKey): boolean {
  return event.hasFinePointer && event.key === 'Enter' && !event.shiftKey && !event.isComposing;
}
